import React, { useEffect } from "react";
import { Button } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';



export function Popup({ onOk = () => { }, onClose = ()=>{}, title="Title", content: ContentElement, children: ButtonElement, 
init=false,
showAction=true }) {
  const [open, setOpen] = React.useState(false);
  useEffect(()=>{
    setOpen(init);
  },[init]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  return (
    <div>
      <div onClick={handleClickOpen}>{ButtonElement}</div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        // sx={{
        //   "& .MuiDialog-container": {
        //     "& .MuiPaper-root": {
        //       // width: "80%",
        //       maxWidth: "80%", // Set your width here
        //     },
        //   },
        // }}
        // fullScreen={true}
        maxWidth={"lg"}
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>{ContentElement}</DialogContent>
        {showAction && (
          <DialogActions>
            <Button
              onClick={() => {
                handleClose();
                onOk();
              }}
              autoFocus
            >
              OK
            </Button>
            <Button onClick={handleClose}>Cancel</Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
}
